import { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { toast } from "sonner";
import { Button } from "@/components/ui/button";
import { Input } from "@/components/ui/input";
import { Label } from "@/components/ui/label";
import { Checkbox } from "@/components/ui/checkbox";
import { api } from "@/lib/api";

export const AuthShell = ({ title, subtitle, children, testId }) => (
  <div className="grid-bg min-h-[calc(100vh-4rem)] px-4 py-12">
    <div className="mx-auto w-full max-w-md panel p-6 sm:p-8" data-testid={testId}>
      <h1 className="font-display text-2xl sm:text-3xl font-semibold">{title}</h1>
      {subtitle && <p className="mt-2 text-sm text-zinc-500">{subtitle}</p>}
      <div className="mt-6 space-y-4">{children}</div>
    </div>
  </div>
);

export const Field = ({ label, id, error, ...props }) => (
  <div className="space-y-1.5">
    <Label htmlFor={id}>{label}</Label>
    <Input id={id} data-testid={id} {...props} />
    {error && <p className="text-xs text-red-400" data-testid={`${id}-error`}>{error}</p>}
  </div>
);

export const Submit = ({ busy, children, testId }) => (
  <Button type="submit" disabled={busy} data-testid={testId} className="w-full bg-[#0071e3] hover:bg-[#0077ed] text-white">
    {busy ? "Lütfen bekleyin…" : children}
  </Button>
);

export function DevModeNote({ show }) {
  if (!show) return null;
  return (
    <p data-testid="dev-email-note" className="rounded border border-yellow-500/40 bg-yellow-500/10 p-2 text-xs text-yellow-700">
      E-posta servisi henüz yapılandırılmadı: kodlar şimdilik yalnızca sunucu kaydına yazılıyor (geliştirme modu).
    </p>
  );
}

export function Consents({ value, onChange }) {
  const items = [
    ["terms", "kullanim-kosullari", "Kullanım koşullarını"],
    ["kvkk", "aydinlatma-metni", "KVKK aydınlatma metnini"],
    ["privacy", "gizlilik", "Gizlilik politikasını"],
  ];
  return (
    <div className="space-y-2">
      {items.map(([k, slug, text]) => (
        <label key={k} className="flex items-start gap-2 text-sm text-zinc-700">
          <Checkbox data-testid={`consent-${k}`} checked={value[k]} onCheckedChange={(c) => onChange({ ...value, [k]: !!c })} className="mt-0.5" />
          <span><Link to={`/yasal/${slug}`} target="_blank" className="text-[#0077ed] underline">{text}</Link> okudum, kabul ediyorum.</span>
        </label>
      ))}
    </div>
  );
}

// REMINDER: DO NOT HARDCODE THE URL, OR ADD ANY FALLBACKS OR REDIRECT URLS, THIS BREAKS THE AUTH
export function GoogleButton() {
  const [cfg, setCfg] = useState(null);
  useEffect(() => { api.get("/auth/google/config").then((r) => setCfg(r.data)).catch(() => setCfg({ enabled: false })); }, []);
  const start = () => {
    if (!cfg?.enabled) { toast.info("Google ile giriş henüz yapılandırılmadı"); return; }
    const state = crypto.getRandomValues(new Uint32Array(4)).join("-");
    sessionStorage.setItem("g_state", state);
    const p = new URLSearchParams({
      client_id: cfg.client_id, redirect_uri: `${window.location.origin}/auth/google`, response_type: "code",
      scope: "openid email profile", state, prompt: "select_account",
    });
    window.location.href = `https://accounts.google.com/o/oauth2/v2/auth?${p}`;
  };
  return (
    <Button type="button" variant="outline" onClick={start} data-testid="google-login-button" className="w-full border-black/[0.08] bg-transparent">
      <svg viewBox="0 0 24 24" className="h-4 w-4"><path fill="#EA4335" d="M12 10.2v3.9h5.5c-.2 1.3-1.6 3.8-5.5 3.8-3.3 0-6-2.7-6-6.1s2.7-6.1 6-6.1c1.9 0 3.1.8 3.8 1.5l2.6-2.5C16.8 3.2 14.6 2.2 12 2.2 6.6 2.2 2.2 6.6 2.2 12s4.4 9.8 9.8 9.8c5.7 0 9.4-4 9.4-9.6 0-.6-.1-1.1-.2-1.6H12z" /></svg>
      Google ile devam et {cfg && !cfg.enabled && <span className="text-xs text-zinc-500">(yakında)</span>}
    </Button>
  );
}
